import { Link } from "wouter";
import { BottomNav } from "../components/BottomNav";

interface Tip {
  q: string;
  a: JSX.Element;
}

const TIPS: Tip[] = [
  {
    q: "What is Orbit?",
    a: (
      <p>
        Orbit is your one card for every shop you visit. Earn points
        at one merchant, see them all in one app, redeem when you've
        got enough.
      </p>
    ),
  },
  {
    q: "How do I join a merchant?",
    a: (
      <p>
        Show the merchant your QR (tap <b>Cards</b> at the bottom),
        or scan the code on their counter. They'll record your visit
        and you'll see your new card pop up under <b>Cards</b>.
      </p>
    ),
  },
  {
    q: "How do I see my points?",
    a: (
      <p>
        Tap <b>Cards</b> at the bottom. Each card shows your balance
        at one shop and the rewards you can claim. Tap a card for
        the full history.
      </p>
    ),
  },
  {
    q: "How do I redeem a reward?",
    a: (
      <ol className="list-decimal pl-5 space-y-1">
        <li>Open the card for the shop you're at.</li>
        <li>Tap the reward you want — it turns into a voucher with a QR.</li>
        <li>Show the QR to the cashier; they'll scan it and apply the reward.</li>
      </ol>
    ),
  },
  {
    q: "I got a paper claim slip — what do I do?",
    a: (
      <p>
        That's a marketplace claim. Tap <b>Discover</b> at the bottom
        and choose <i>Claim a code</i>, or scan the QR on the slip
        with your phone camera. You'll be enrolled with that shop and
        receive a starter bonus.
      </p>
    ),
  },
  {
    q: "What's in the Inbox?",
    a: (
      <p>
        Messages from shops you've joined: new rewards, special
        offers, opening hours, your monthly recap. Tap any message
        to open it. The badge on the bottom bar shows unread count.
      </p>
    ),
  },
  {
    q: "Can I stop marketing messages?",
    a: (
      <p>
        Yes. Go to <b>Profile → Push notifications</b> for app pushes,
        or open any marketing email/SMS and tap the unsubscribe link.
        Service messages (like account verification) will still arrive.
      </p>
    ),
  },
  {
    q: "I lost my phone or got a new one",
    a: (
      <p>
        Sign in with your same phone number or email and your cards,
        balances, and vouchers will all be there. If you forgot your
        password, tap <i>Forgot password</i> on the sign-in screen.
      </p>
    ),
  },
  {
    q: "Privacy and my data",
    a: (
      <p>
        Under <b>Profile → Privacy & data</b> you can review every
        consent you gave, download all your data as a file, or delete
        your account entirely. Deletions take effect within 30 days.
      </p>
    ),
  },
];

export default function HelpPage() {
  return (
    <div className="min-h-screen bg-cream pb-24">
      <header className="bg-white border-b border-amber-light px-4 py-4">
        <div className="max-w-md mx-auto flex items-center gap-3">
          <Link href="/profile" className="text-navy text-sm">
            ← Back
          </Link>
          <h1 className="text-lg font-semibold text-navy">Help</h1>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-6 space-y-3">
        <p className="text-sm text-ink-dark mb-4">
          Quick answers to the most common questions. Tap a question
          to expand.
        </p>
        {TIPS.map((t, i) => (
          <details
            key={i}
            className="rounded-lg border border-amber-light bg-white"
          >
            <summary
              className="cursor-pointer px-4 py-3 font-medium text-navy"
              data-testid={`help-q-${i}`}
            >
              {t.q}
            </summary>
            <div className="px-4 pb-4 text-sm text-ink-dark leading-relaxed">
              {t.a}
            </div>
          </details>
        ))}

        <p className="text-center text-xs text-ink-dark/70 pt-6">
          Still stuck? Email{" "}
          <a href="mailto:support@orbit.m42" className="underline">
            support@orbit.m42
          </a>
        </p>
      </main>

      <BottomNav />
    </div>
  );
}
